var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85714 7.5C7.3525 7.5 6.88868 7.68326 6.52254 7.98973L4.23491 6.48846C4.30266 6.1667 4.30266 5.83328 4.23491 5.51152L6.52254 4.01025C6.88868 4.31674 7.3525 4.5 7.85714 4.5C9.0406 4.5 10 3.49263 10 2.25C10 1.00737 9.0406 0 7.85714 0C6.67368 0 5.71429 1.00737 5.71429 2.25C5.71429 2.41777 5.73192 2.58117 5.76509 2.73846L3.47746 4.23973C3.11132 3.93326 2.6475 3.75 2.14286 3.75C0.959397 3.75 0 4.75737 0 6C0 7.24263 0.959397 8.25 2.14286 8.25C2.6475 8.25 3.11132 8.06674 3.47746 7.76027L5.76509 9.26154C5.73128 9.42193 5.71424 9.58572 5.71429 9.75C5.71429 10.9926 6.67368 12 7.85714 12C9.0406 12 10 10.9926 10 9.75C10 8.50737 9.0406 7.5 7.85714 7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.5c6a12b9f8d7db3be5e5356bc796e7a7.svg";
export { ForwardRef as ReactComponent };